import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { products, pageColors } from "../mock";
import { useCart } from "../context/CartContext";
import { ShoppingBag } from "lucide-react";

const Shop = () => {
  const { addItem, openCart } = useCart();
  const navigate = useNavigate();
  const visibleProducts = products.filter((p) => p.visible !== false);

  React.useEffect(() => {
    document.title = "TMM|SHOP";
  }, []);

  return (
    <>
      <Header hoverColor={pageColors.shop} compact={false} />
      <div className="shop-page">
        <div className="shop-hero">
          <h1 className="shop-title">SHOP</h1>
          <p className="shop-sub">
            Wearables, prints, and small objects from The Monde Mania.
          </p>
          <div className="shop-hero-actions">
            <button className="shop-cart-btn" onClick={openCart}>
              <ShoppingBag size={18} /> View cart
            </button>
          </div>
        </div>

        <div className={`shop-grid${visibleProducts.length === 1 ? " shop-grid-single" : ""}`}>
          {visibleProducts.map((p) => (
            <div key={p.id} className="product-card">
              <div className="product-media">
                <img src={p.image} alt={p.name} />
              </div>
              <div className="product-body">
                <div className="product-tag">{p.tag}</div>
                <div className="product-name">{p.name}</div>
                <div className="product-desc">{p.description}</div>
                <div className="product-footer">
                  <div className="product-price">${p.price.toFixed(2)}</div>
                  {p.link ? (
                    <button
                      className="product-add"
                      onClick={() => navigate(p.link)}
                      aria-label={`View ${p.name}`}
                      data-testid={`shop-view-${p.id}`}
                    >
                      View
                    </button>
                  ) : (
                    <button
                      className="product-add"
                      onClick={() => addItem(p, 1)}
                      aria-label={`Add ${p.name} to cart`}
                    >
                      Add to cart
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Shop;
